import request from "@/utils/request";

// 获取列表数据
export function querySupplierList(data) {
  return request({
    url: "/supplier/table",
    method: "post",
    data,
  });
}
export function querySupplierData(params) {
  return request({
    url: "/supplier/queryList",
    method: "get",
    params,
  });
}

// 新增列表数据
export function insertSupplier(data) {
  return request({
    url: "/supplier/save",
    method: "post",
    data,
  });
}

// 编辑列表数据
export function updateSupplier(data) {
  return request({
    url: "/supplier/update",
    method: "post",
    data,
  });
}

// 根据id获取详情
export function querySupplierById(id) {
  return request({
    url: `/supplier/info/${id}`,
    method: "get",
  });
}

// 删除供应商
export function deleteSupplier(id) {
  return request({
    url: `/supplier/${id}`,
    method: "delete",
  });
}

//查询项目
export function queryProjectList(params) {
  return request({
    url: "/engProject/page",
    method: "get",
    params: params,
  });
}
